import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MemberManagementService } from './member-management.service';
import {
  InvitationCodesInfoModel, MemberProfileInfoModel,
  MemberUpdateRequestModel,
} from './member-info.model';
import { EnumModel } from '../../shared/objects/EnumModel';
import { DateHelper } from '../../shared/helpers/date-helper';
import { StatisticDataModel } from '../../shared/objects/statistics-group.model';
import { UnsubscribeDestroyHelper } from '../../shared/helpers/unsubscribe.helper';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-member-database',
  templateUrl: './member-database.component.html',
  providers: [MemberManagementService],
  styleUrls: ['./member-database.component.less'],
})
export class MemberDatabaseComponent extends UnsubscribeDestroyHelper implements OnInit {
  initialState: string;

  showConfirmMembershipChange: boolean;
  firstName: string;
  lastName: string;

  @Input() showMember: boolean;
  @Input() memberId;
  @Output() showMemberChange = new EventEmitter<boolean>();
  activeTab = 1;
  disableDate = false;
  closeMember = false;


  memberPopupModel = new MemberProfileInfoModel();
  invitationCodesList = new Array<InvitationCodesInfoModel>();
  memberUpdateRequestModel = new MemberUpdateRequestModel();
  statisticModel: StatisticDataModel[];

  membershipOptions: EnumModel[] = [
    new EnumModel('Standard', 'Standard'),
    new EnumModel('Premium', 'Premium'),
  ];
  selectedMembership = this.membershipOptions[0];
  pendingSelectedMembership = this.membershipOptions[0];

  expiryDateOptions: EnumModel[] = [
    { id: 'noChange', name: 'No change' },
    { id: 3, name: '3 months' },
    { id: 6, name: '6 months' },
    { id: 12, name: '12 months' },
    { id: 'unlimited', name: 'Unlimited' },
    { id: 'specific', name: 'Specific date' }];
  selectedExpiryDate = this.expiryDateOptions[0];

  currentExpirationDate: Date;
  currentExpirationDateString: string;
  newExpirationDateString = null;
  newExpirationDate = null;
  customExpirationDate = new Date;

  showCancelMemberConfirmation = false;

  showRestoreEmailConfirmation = false;

  selectedImageForPreview: string;

  minDate = new Date();

  constructor(private memberManagementService: MemberManagementService) {
    super();
  }

  ngOnInit() {
    this.memberManagementService.getMemberAnalytic(this.memberId).pipe(
      takeUntil(this.unsubscribeSubject)
    ).subscribe(
      (response: StatisticDataModel[]) => {
        this.statisticModel = response;
      },
      (error) => console.log(error),
    );

    this.memberManagementService.getMemberProfileInfo(this.memberId).pipe(
      takeUntil(this.unsubscribeSubject)
    ).subscribe(
      (response: MemberProfileInfoModel) => {
        this.memberPopupModel = response;
        const nameParts = response.name.split(' ');
        this.firstName = nameParts[0];
        this.lastName = nameParts.slice(1).join(' ');

        if (this.memberPopupModel.website && this.memberPopupModel.website.length) {
          // tslint:disable-next-line:triple-equals
          if (this.memberPopupModel.website.indexOf('http') != 0) {
            this.memberPopupModel.website = `http://${this.memberPopupModel.website}`;
          }
        }
        this.selectedMembership = EnumModel.GetByIdOrFirst(this.membershipOptions, this.memberPopupModel.membershipType);
        this.pendingSelectedMembership = EnumModel.GetByIdOrFirst(this.membershipOptions, this.memberPopupModel.membershipType);

        this.currentExpirationDate = this.memberPopupModel.expiryDate ? this.memberPopupModel.expiryDate : null;
        if (this.memberPopupModel.membershipType === 'Premium') {
          this.currentExpirationDateString = this.memberPopupModel.expiryDate ?
            (new Date(this.memberPopupModel.expiryDate)).toLocaleDateString('en-GB') : 'Unlimited';
        } else {
          this.expiryDateOptions.splice(0, 1);
          this.selectedExpiryDate = this.expiryDateOptions[0];
        }

        this.saveInitialState();
      },
      (error) => console.log(error),
    );


    this.memberManagementService.getInvitedByMember(this.memberId).pipe(
      takeUntil(this.unsubscribeSubject)
    ).subscribe(
      (response: InvitationCodesInfoModel[]) => {
        this.invitationCodesList = response;
      },
      (error) => {
        console.log(error);
      },
    );
  }

  saveInitialState() {
    this.initialState =
      JSON.stringify(this.memberPopupModel, this.replacer) +
      JSON.stringify(this.selectedMembership) +
      JSON.stringify(this.selectedExpiryDate) +
      JSON.stringify(this.currentExpirationDate);
  }

  replacer(key, value) {
    // if (key=="email") return undefined;
  }

  stateChanged() {


    const currentState =
      JSON.stringify(this.memberPopupModel, this.replacer) +
      JSON.stringify(this.selectedMembership) +
      JSON.stringify(this.selectedExpiryDate) +
      JSON.stringify(this.currentExpirationDate);
    return currentState !== this.initialState || currentState.length !== this.initialState.length;
  }

  changeTab(selected) {
    this.activeTab = selected;
  }

  close() {
    this.showMemberChange.emit(false);
    this.closeMember = false;
  }

  confirmMemebershipChange(item: EnumModel) {
    if (this.pendingSelectedMembership.id === item.id || this.pendingSelectedMembership.id === 'Standard' || !this.memberPopupModel.isPayingMember) {
      this.onChange(item);
      return;
    } else {
      this.showConfirmMembershipChange = true;
    }
  }

  membershipChangeConfirmed() {
    this.pendingSelectedMembership = this.selectedMembership;
    this.onChange(this.selectedMembership);
    this.showConfirmMembershipChange = false;
  }

  cancelMembershipChange() {
    this.selectedMembership = this.pendingSelectedMembership;
    this.showConfirmMembershipChange = false;
  }

  onChange(item: EnumModel) {
    this.selectedExpiryDate = this.expiryDateOptions[0];
    this.recalculateExpireDates();
  }


  recalculateExpireDates() {
    if (this.selectedMembership.id === 'Standard' || this.selectedExpiryDate.id === 'noChange') {
      this.newExpirationDate = null;
      this.newExpirationDateString = null;
      return;
    }
    if (this.selectedExpiryDate.id === 3 || this.selectedExpiryDate.id === 6 || this.selectedExpiryDate.id === 12) {
      this.newExpirationDate = DateHelper.addMonths(this.currentExpirationDate, this.selectedExpiryDate.id);
      this.newExpirationDateString = this.newExpirationDate.toLocaleDateString('en-GB');
    } else if (this.selectedExpiryDate.id === 'specific') {
      this.customExpirationDate = new Date();
      this.newExpirationDate = new Date();
      this.newExpirationDateString = this.newExpirationDate.toLocaleDateString('en-GB');
    } else if (this.selectedExpiryDate.id === 'unlimited') {
      this.newExpirationDate = null;
      this.newExpirationDateString = 'Unlimited';
    }
  }

  setCustomExpirationDate(e) {
    this.newExpirationDate = this.customExpirationDate;
    this.newExpirationDateString = this.customExpirationDate.toLocaleDateString('en-GB');
  }

  confirmClose() {
    if (this.stateChanged()) {
      this.closeMember = true;
    } else {
      this.close();
    }
  }

  saveConfirmed() {
    this.updateMember();
  }

  updateMember() {
    this.memberUpdateRequestModel.memberId = this.memberId;
    this.memberUpdateRequestModel.firstName = this.firstName;
    this.memberUpdateRequestModel.lastName = this.lastName;
    delete this.memberUpdateRequestModel.name;
    this.memberUpdateRequestModel.email = this.memberPopupModel.email;
    this.memberUpdateRequestModel.workEmail = this.memberPopupModel.workEmail;
    this.memberUpdateRequestModel.membershipType = this.selectedMembership.id;
    this.memberUpdateRequestModel.updateExpirationDate = this.selectedExpiryDate.id !== 'noChange' || this.memberPopupModel.membershipType !== this.selectedMembership.id;
    this.memberUpdateRequestModel.expiryDate = this.newExpirationDate;

    this.memberUpdateRequestModel.standardInvitations = this.memberPopupModel.standardInvitationsLeft;
    this.memberUpdateRequestModel.premiumInvitations = this.memberPopupModel.premiumInvitationsLeft;
    this.memberUpdateRequestModel.canCreatePremiumInvitationCodes = this.memberPopupModel.canCreatePremiumInvitationCodes;

    this.memberManagementService.memberUpdate(this.memberUpdateRequestModel).pipe(
      takeUntil(this.unsubscribeSubject)
    ).subscribe(
      (response) => {
        this.showMemberChange.emit(true);
        this.closeMember = false;
      },
      (error) => console.log(error),
    );
  }

  restoreRegistrationEmail() {
    this.memberManagementService.restoreRegistrationEmail(this.memberId).pipe(
      takeUntil(this.unsubscribeSubject)
    ).subscribe((response) => {
      this.memberPopupModel.email = this.memberPopupModel.registrationEmail;
      this.closePopUp();
    });
  }

  closePopUp() {
    this.showCancelMemberConfirmation = false;
    this.showRestoreEmailConfirmation = false;
    this.selectedImageForPreview = null;
  }

  cancelMemberConfirmed() {
    this.memberManagementService.cancelMembership(this.memberId).pipe(
      takeUntil(this.unsubscribeSubject)
    ).subscribe(
      (r) => {
        this.showMemberChange.emit(true);
        this.showCancelMemberConfirmation = false;
      }, (e) => this.showCancelMemberConfirmation = false);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/member-management/member-database.component.ts